import { z } from 'zod'
import { SUPPORT_CATEGORY_IDS } from '../../constants/support'

export const CreateSupportTicketRequest = z.object({
  email: z.string().trim().min(1),
  subject: z.string().trim().min(1),
  content: z.string().trim().min(1),
  category: z.enum(SUPPORT_CATEGORY_IDS),
  fileIds: z.array(z.string().trim()).max(10).optional(),
})

export type CreateSupportTicketRequest = z.infer<typeof CreateSupportTicketRequest>

export interface CreateSupportTicketResponse {
  ticketId: string
  contactId: string
  contactCreated: boolean
}

export const SUPPORT_ATTACHMENT_CONTENT_TYPES = ['application/pdf', 'image/png', 'image/jpeg'] as const

export const GenerateAttachmentUploadUrlRequest = z.object({
  fileName: z.string().trim().min(1),
  contentType: z.enum(SUPPORT_ATTACHMENT_CONTENT_TYPES),
})

export type GenerateAttachmentUploadUrlRequest = z.infer<typeof GenerateAttachmentUploadUrlRequest>

export interface AttachmentUploadUrlResponse {
  uploadUrl: string
  objectKey: string
}
